import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { IPortfolio } from "src/components/portfolio/PortfolioTable";

export type SortDirection = "asc" | "desc" | null;

export interface SortConfig {
  key: string | null;
  direction: SortDirection;
}

export function sortArray<T>(array: T[], config: SortConfig): T[] {
  if (!config.key || !config.direction) return array;

  return [...array].sort((a, b) => {
    const aVal = a[config.key as keyof T];
    const bVal = b[config.key as keyof T];

    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return config.direction === "asc" ? aNum - bNum : bNum - aNum;
    }
    const aStr = String(aVal ?? "");
    const bStr = String(bVal ?? "");
    return config.direction === "asc"
      ? aStr.localeCompare(bStr)
      : bStr.localeCompare(aStr);
  });
}

export const getEffectiveForDate = (row: IPortfolio): number => {
  // If row has children → use LAST child date
  if (row.hasChildren && row.children?.length) {
    return Math.max(...row.children.map((c) => new Date(c.for_date).getTime()));
  }

  // Otherwise use parent date
  return row.for_date ? new Date(row.for_date).getTime() : 0;
};

export const getSortIcon = (sortConfig: SortConfig | null, key: string) => {
  const baseClasses =
    "w-3 h-3 absolute right-1 top-1/2 -translate-y-1/2 transition-opacity";

  if (!sortConfig || sortConfig.key !== key) {
    return (
      <ArrowUpDown
        className={`${baseClasses} opacity-0 group-hover:opacity-60`}
      />
    );
  }

  if (sortConfig.direction === "asc") {
    return <ArrowUp className={`${baseClasses} opacity-100`} />;
  }

  if (sortConfig.direction === "desc") {
    return <ArrowDown className={`${baseClasses} opacity-100`} />;
  }

  return (
    <ArrowUpDown
      className={`${baseClasses} opacity-0 group-hover:opacity-60`}
    />
  );
};
